import { gql } from '@apollo/client'

export const Query = gql`
  query EventShifts($companyId: ID!, $filters: ShiftFilters, $order: ShiftOrder, $after: String, $before: String, $first: Int, $last: Int) {
    shifts(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        user { id displayName }
        shiftRole { id name }
        start
        finish
        rateCents
        event { id currency description }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
